// extracted by mini-css-extract-plugin
export default {"pay":"verify_pay__J2A74","body":"verify_body__RMmOF","line":"verify_line__tAED+","error":"verify_error__gojzK"};